export class Documento {

    public id: String;
    public descripcion: String;
    constructor(id: String, descripcion: String ) {
        this.id = id;
        this.descripcion = descripcion;
    }
}
